import { render, staticRenderFns } from "./FormDivisao.vue?vue&type=template&id=1691f4f4"
import script from "./FormDivisao.vue?vue&type=script&lang=js"
export * from "./FormDivisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports